import type { Text } from 'slate';

export enum DeepLinkVariants {
  IMAGE_SLICE = 'imageSlice',
  POINT = 'point',
  STUDY = 'study',
}

export const DEFAULT_STUDY_DATE_VALUE = -8.64e15; // earliest date in JS
export const MISSING_STUDY_DESCRIPTION = '<missing study description>';
export const MISSING_STUDY_DATE = '<missing study date>';

export const createEmptyTextNode = (): Text => ({ text: '' });
export const createDelimiterTextNode = (): Text => ({ text: ',' });

export const REPLACEABLE_DEFAULT_COMPARISON_TEXTS: readonly string[] = ['none available'];
